module.exports = __webpack_public_path__ + "img/img-56.258acf05.png";